<template>
  <div
    :id="rowUniqueId"
    :class="[
      $style[`formError${inputSize}`],
      {
        [$style.formErrorVersion2]: modelValue.version2,
        [$style.formErrorVersion2Checkbox]: modelValue.type === 'checkbox',
        awSrOnlyAbs: !(hasError && errorMessage),
      }
    ]"
    aria-live="assertive"
  >
    <span v-if="hasError && errorMessage" v-text="errorMessage" />
  </div>
</template>

<script>
  import { useNuxtApp } from 'nuxt/app';
  import { getFormRowErrorMessage } from '~~/common/utils/form';
  import formMixin from '~~/common/mixins/formMixin';

  export default {
    name: 'AwFormError',
    mixins: [formMixin],
    props: {
      inputSize: {
        type: String,
        default: 'lg',
        validator: value => ['xs', 'md', 'lg'].includes(value),
      },
    },
    computed: {
      errorMessage () {
        return this.getErrorMessage();
      },
    },
    methods: {
      getErrorMessage () {
        return getFormRowErrorMessage(
          useNuxtApp(),
          this.rowValidator,
          this.modelValue.tokens,
        );
      },
    },
  };
</script>

<style module lang="scss" rel="stylesheet/scss">
$input-sizes: (
  "xs": (
    "margin-top": 2px,
  ),
  "md": (
    "margin-top": 6px,
  ),
  "lg": (
    "margin-top": 12px,
  ),
);
%formError {
  @include font(null, 12px, 16px);
  color: $color-error-v1-text;

  &:not(:global(.awSrOnlyAbs)) {
    position: relative;
  }
}

@each $size, $values in $input-sizes {
  .formError#{$size} {
    @extend %formError;
    margin-top: map.get($values, "margin-top");
  }
}

.formErrorVersion2 {
  @include font($font-weight-normal-v2, 14px, 20px);
  margin: 8px 0;
  color: $color-error-v2-text;

  &Checkbox {
    margin-right: 0;
    margin-left: 0;
  }
}
</style>
